module.exports = __webpack_public_path__ + "static/media/flowers_yorkshire_getty_mobile.56fb819d.jpg";